import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { LOCALE_TYPE } from './const/localeType';
import en from './locale/en.json';
import ru from './locale/ru.json';

Vue.use(VueI18n);

const messages = {
  en,
  ru,
};

const getUserLocale = async () => {
  let locale;
  const userLang = window.navigator.language || window.navigator.userLanguage;
  if (userLang === LOCALE_TYPE.RU) locale = LOCALE_TYPE.RU;
  else locale = LOCALE_TYPE.EN;

  localStorage.setItem('locale', locale);

  return locale;
};

const currentLocale = localStorage.getItem('locale') || getUserLocale() || LOCALE_TYPE.RU;

const i18n = new VueI18n({
  locale: currentLocale,
  fallbackLocale: LOCALE_TYPE.RU,
  messages,
});

export default i18n;
